import { connect } from 'react-redux';
import { fetchAmenities } from '../../actions/amenities';
import AmenitiesList from './AmenitiesList';

function mapStateToProps({ amenities, stationInfo }, ownProps) {
  const { stationId } = ownProps;
  const station = stationInfo.stationsById[stationId];
  const amenityIds = station?.amenities || [];
  const amenitiesList = amenityIds.map(amenityId => amenities.byId[amenityId])?.filter(Boolean);

  return {
    isFetching: amenities.isFetching,
    amenitiesList,
    error: amenities.error,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchAmenities: stationId => dispatch(fetchAmenities(stationId)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AmenitiesList);
